
import React, { useEffect, useState, useCallback } from "react";
import { getRequestInAssets as getRequest } from "services/axiosAssetsBaseClient";
import TableAndSearch from "../common/TableAndSearch";
import { useHistory, Link } from "react-router-dom";
import notificationService from "services/notification.service";
import LocalStorageService from "services/tokenlocalstorage.service";
import { NotificationManager } from "react-notifications";
import ConfirmationDialog from "../common/ConfirmDialog";


var allZones;
var tempSearch;

export default function Eemmmll(props) {
  const { headerFilter } = props;

  const [siteHeaderFilterData, setSiteHeaderFilterData] = useState([]);
  // const [filter, setFilter] = useState(filterInitialValue);
  const [siteData, setSiteData] = useState([]);
  const [siteStatusIcon, setSiteStatusIcon] = useState(false);
  const [siteStatus, setSiteStatus] = useState(true);
  const [message, setMessage] = useState("");
  const [activepageCount, setActivePageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [tempSwap, setTempSwap] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const paginationCountHanlde = (count) => {
    setActivePageCount(count);
  };

  const sitesHeaderFilterHandle = (searchString) => {
    if (
      typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
    ) {
    } else {
      localStorage.setItem("lastTableSearch", searchString);
    }

    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));

    var query =
      // (headerFilterObj?.enterprise
      //   ? "enterprise=" + headerFilterObj.enterprise
      //   : "") +
      (headerFilterObj?.stateId ? "&stateId=" + headerFilterObj?.stateId : "") +
      (headerFilterObj?.cityId ? "&cityId=" + headerFilterObj?.cityId : "") +
      (headerFilterObj?.zoneId ? "&zoneId=" + headerFilterObj?.zoneId : "") +
      (typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
        ? ""
        : "&filter=" + encodeURIComponent(searchString));

    query = query ? "?" + query : "";

    try {
      getRequest("bss/siteInfo" + query)
        .then((resp) => {
          if (resp?.data && resp.data?.sites) {
            setSiteHeaderFilterData(resp?.data?.sites);
            // props.assetCount(() => resp?.data?.count);
            props.assetCount(() => resp?.data?.sites.length);
            setTotalCount(resp?.data?.sites.length)
          }
        })
        .catch((e) => {
          console.log(e, "ERROR");
        });
    } catch (err) {
      console.log(err);
    }
  };

  const getAllZones = useCallback(async (id) => {
    await getRequest("zone/getAllZones?pageSize=1000&pageNumber=0")
      .then((res) => {
        if (res.data != null) {
          allZones = res?.data?.content;
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    tempSearch = localStorage.getItem("lastTableSearch");
    if (headerFilterObj && Object.keys(headerFilterObj).length > 0) {
      sitesHeaderFilterHandle(tempSearch.trim());
    }
    if (headerFilterObj && !headerFilterObj) {
      headerFilter = false;
      setSiteHeaderFilterData([]);
      sitesHeaderFilterHandle(tempSearch.trim());
    }
  }, [headerFilter]);

  useEffect(() => {
    tempSearch = localStorage.getItem("lastTableSearch");
    if (tempSearch === null) {
      tempSearch = localStorage.setItem("lastTableSearch", "");
      sitesHeaderFilterHandle();
    } else {
      sitesHeaderFilterHandle(tempSearch.trim());
    }
    // props.assetCount(() => 0);
    // getZoneData();
    window.scrollTo(0, 0);
  }, []);

  const history = useHistory();

  const viewSiteList = (id, enterpriseName) => {
    history.push("/Assets/ViewSite/" + id + `/view`);
  };

  const updateSiteList = (id, enterpriseName) => {
    history.push("/Assets/UpdateSite/" + id );
  };

  const statusActive = useCallback(async (data) => {
    if (data.isActive) {
    } else {
      setSiteStatus(true);
    }
    await getRequest(
      `bss/changeStatusSite?isActive=${!data.isActive}&siteId=${
        data.siteId
      }&enterprise=${data.enterpriseName}`
    )
      .then((res) => {
        if (res.data != null) {
          // getSite();
          siteHeaderFilterData.filter((data) => {
            if (data.siteId == res.data.id) {
              data.status = res.data.status;
              data.isActive = res.data.isActive;
              // siteIndex = res.data.id;
            }
          });
          setTempSwap(res.data);
          // sitesHeaderFilterHandle();
          notificationService.showNonBlacklisted(res?.config?.url, res.message);
        }
      })
      .catch((err) => {
        notificationService.showNonBlacklistedError(
          err?.config?.url,
          err?.response?.data?.message
        );
      });
  });

  const columns = React.useMemo(
    () => [
      {
        Header: "Site Name",
        width: 250,
        accessor: "siteName",
      },
      {
        Header: "Zone Name",
        width: 250,
        accessor: "zoneName",
      },
      {
        Header: "Site Status",
        accessor: "status",
        width: 250,
        Cell: (row) => {
          return (
            <>
              {row.row.values.status === "UNDERMAINTENANCE" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "blueviolet",
                    border: "1px",
                    width: "160px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px",
                  }}
                >
                  <span style={{ margin: "0px" }}>Under Maintenance</span>
                </p>
              ) : row.row.values.status === "UPCOMING" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "orange",
                    border: "1px",
                    width: "130px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px 0px",
                  }}
                >
                  <span style={{ margin: "0px" }}>Upcoming</span>
                </p>
              ) : row.row.values.status === "COMMISSIONED" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "blue",
                    border: "1px",
                    width: "130px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px 0px",
                  }}
                >
                  <span style={{ margin: "0px" }}>Commissioned</span>
                </p>
              ) : row.row.values.status === "OFFLINE" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "rgb(199, 23, 32)",
                    border: "1px",
                    width: "130px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px 0px",
                  }}
                >
                  <span style={{ margin: "0px" }}>Offline</span>
                </p>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
      {
        Header: "Swap Stations",
        width: 250,
        accessor: "swapStations",
        Cell: (row) => { 
          return(
            <div style={{ paddingLeft:"40px" }}>{row.row?.original?.swapStations ? row.row?.original?.swapStations : 0}</div>
        ) },
      },
      {
        Header: "Action",
        accessor: "id",
        disableSortBy: true,
        width: 50,
        // textAlign:"center",
        Cell: (row) => {
          var id = row.row.original.siteId
            ? row.row.original.siteId
            : row.row.original.id
            ? row.row.original.id
            : 0;
          var enterprise = row.row.original.enterpriseName
            ? row.row.original.enterpriseName
            : row.row.original.enterprise
            ? row.row.original.enterprise
            : "";
          return (
            <>
              <div style={{ width: "100% !important", textAlign: "center" }}>
                <img
                  src={require("assets/eye.png").default}
                  style={{ margin: "8px", cursor: "pointer" }}
                  onClick={() => viewSiteList(id, enterprise)}
                ></img>
                <img
                  src={require("assets/pencil.png").default}
                  onClick={() => updateSiteList(id, enterprise)}
                  style={{ cursor: "pointer" }}
                ></img>
                  <ConfirmationDialog
                  data={row.row.original}
                  handleStatus={(data) => { statusActive(data) }}
                  assets={"Site"}
                  name={row.row.original.siteName}
                />
                {/* {row.row.original.isActive ? (
                  <button
                    onClick={() => siteStatusHandle(row)}
                    style={{ border: "none", margin: "8px" }}
                  >
                    <img
                      src={require("assets/active.png").default}
                      height={"20px"}
                      width={"20px"}
                    ></img>
                  </button>
                ) : (
                  <button
                    onClick={() => siteStatusHandle(row)}
                    style={{ border: "none", margin: "8px", cursor: "pointer" }}
                  >
                    <img
                      src={require("assets/inactive.png").default}
                      height={"20px"}
                      width={"20px"}
                    ></img>
                  </button>
                )} */}
              </div>
            </>
          );
        },
      },
    ],
    [siteHeaderFilterData, tempSwap]
  );

  return (
    <div>
      <h2 style={{ textAlign: "center", color: "green" }}>{message}</h2>
      <h2 style={{ textAlign: "center", color: "green" }}>{message}</h2>
      <TableAndSearch
        totalCount={totalCount}
        activepageCount={activepageCount}
        paginationCountHanlde={paginationCountHanlde}
        searchOpts={{
          onSearch: sitesHeaderFilterHandle,
          placeholder: "Search By Site Name",
          setSearch: setSearch,
        }}
        columns={columns}
        data={siteHeaderFilterData}
        tigger={props?.tigger}
        tabTemp={props.tabTemp}
        // data={siteData}
        scroll={true}
        tempSearch={tempSearch}
        headerFilterParms={headerFilter}
      />
    </div>
  );
}
//siteData
Eemmmll.inStorybook = true;
